const SubjectIntro = ({ subject = "", intro = "" }) => (
  <div>
    <p className="pdf-brand pdf-m-0">Sub: {subject}</p>
    <p
      className="pdf-pre-line"
      dangerouslySetInnerHTML={{ __html: intro }}
    />
  </div>
)

export default SubjectIntro
